import React from "react";
import { Box, Typography, useTheme, alpha } from "@mui/material";
 
const FooterSection = () => {
  const theme = useTheme();
  const perlColors = theme.custom?.perlColors || {};
  const perlTypography = theme.custom?.perlTypography || {};
  const brandColor = perlColors.brandColor || "#ff6034";
 
  return (
    <>
      {/* Footer Note */}
        <Box
            sx={{
                mt: 0,
                p: 1,
                // bgcolor: alpha(pptColors.white, 0.03),
                border: perlColors.border,
                borderRadius: "8px",
                textAlign: "left",
        }}
        >
            <Typography
                variant="caption"
                sx={{
                color: perlColors.textPrimary,
                fontSize: "12px",
                fontFamily: perlTypography.family,
                letterSpacing: "0.3px",
                fontStyle: "italic",
                }}
            >
                ⚠️ AI-Generated Results • For illustration purposes only.
            </Typography>
        </Box>
    </>
  );
};
export default FooterSection;